const brandsNotRequiringTC = ['homeaway_us', 'vrbo', 'vr', 'homeaway_ca', 'homeaway_mx'];

function isTCRequired(brand) {
    if (brandsNotRequiringTC.includes(brand)) {
        return false;
    }
    return true;
}

export default {
    isTCRequired
};
